<template>
  <div :class="{ 'card': !inset }">
    <div :class="{ 'card-body': !inset }">
      <div class="text-center my-3">
        <div class="d-flex align-items-center justify-content-center">
          <span class="mr-3">
            <span
              v-if="loading"
            >
              <i class="fa fa-spin fa-circle-o-notch fa-fw"></i>
            </span>
            <span
              v-if="!loading"
            >
              <i :class="`fa ${leaderboardViewIcon} fa-fw`"></i>
            </span>
          </span>
          <b-form-radio-group
            v-model="period"
            size="sm"
            :options="[
              {
                text: 'Today',
                value: 'day'
              },
              {
                text: '7 Days',
                value: 'last7days'
              },
              {
                text: '30 Days',
                value: 'last30days'
              },
              {
                text: 'YTD',
                value: 'ytd'
              }
            ]"
            :button-variant="radioButtonVariant"
            buttons
          ></b-form-radio-group>
        </div>
      </div>
      <widget
        ref="leaderboardWidget"
        v-model="leaderboardWidgetConfig"
        class="mb-3"
      ></widget>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/dashboard/Widget'
import { getBusinessPlanLeaderboard } from '@/api'

export default {
  components: {
    Widget,
  },
  props: {
    value: {
      type: String,
      default: 'conversations'
    },
    userId: {
      type: [String, Number],
      default: null
    },
    year: {
      type: [String, Number],
      default: null
    },
    inset: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      explore: '#',
      view: this.value,
      period: 'last7days',
      entries: [],
      count: 0,
      loading: false
    }
  },
  computed: {
    radioButtonVariant () {
      if (this.theme === 'dark') {
        return 'dark'
      } else {
        return 'white'
      }
    },
    leaderboardWidgetConfig () {
      return {
        component: 'Leaderboard',
        title: null,
        data: {
          entries: this.entries
        },
        options: {
          inset: true,
          shadow: false,
          hideHeader: true
          //, hideFooter: true
        }
      }
    },
    leaderboardViewIcon () {
      return this.getLeaderboardViewIcon(this.view)
    },
    leaderboardTitle () {
      return {
        conversations: 'Conversations',
        appointments: 'Appointments',
        sales: 'Sales'
      }[this.view]
    },
    exploreLabel () {
      return `All ${this.count}`
    }
  },
  watch: {
    value () {
      this.view = this.value
    },
    view () {
      this.updateLeaderboard()
    },
    period () {
      this.updateLeaderboard()
    }
  },
  mounted () {
    this.updateLeaderboard()
  },
  methods: {
    async updateLeaderboard () {
      this.loading = true
      let response = await getBusinessPlanLeaderboard(this.view, this.period, this.userId, this.year)
      this.entries = response.data.entries
      this.count = response.data.count
      this.loading = false
    },
    getLeaderboardViewIcon (value) {
      switch(value) {
        case 'conversations':
          return 'fa-comments'
        case 'income':
          return 'fa-money'
        case 'sales':
          return 'fa-home'
        case 'appointments':
          return 'fa-calendar'
        default:
          return 'far fa-square'
      }
    }
  }
}
</script>